import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import useActionsFilteredAlertsMessages from '@/components/AlertsMessages/composables/useActionsFilteredAlertsMessages'
import { AlertMessage, AlertMessageVisibility } from '@/store/modules/alertsMessages/alertsMessagesTypes'

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'AlertListItemComponent',
  props: {
  alert: {
    type: Object as PropType<AlertMessage>,
    required: true
  }
},
  setup(__props) {

const props = __props;



// COMPOSABLE
const { goToAlertsMessagesURL } = useActionsFilteredAlertsMessages()

// METHODS
async function goToAlert() {
  goToAlertsMessagesURL(props.alert)
}

return { __sfc: true,props, goToAlertsMessagesURL, goToAlert, AlertMessageVisibility }
}

})